export class StationMaster {
}

export class StationMasterFilterModel {
    intStationID:number;    
}

export class ParentStationMasterFilterModel {
    intParentStationID:number;    
}

export class ContactPersonDesignationFilterModel {
    intPersonDesignationID:number;    
}
 export class GeoStructureFilterModel
 {
    intGeoStructureID:number;
 }
export class InsertStationMasterFilterModel {
    public intStationID: number;
    public intStationTypeID : number;
    public intParentStationID : number;
    public intRegionalLanguageID1 : number;
    public intRegionalLanguageID2 : number;
    public bActive : boolean=true;
    public strStationName: string='';
    public strStationCode : string='';
    public strDisplayName: string='';
    //public strLat : string='';
    //public strLong: string='';
    public strAlias : string='';
    public strRegionalValue1: string='';
    public strRegionalValue2 : string=''; 
    public intGeoStructureID: number;
    public intDepotID: number;
    public intBookingCenterID: number;
    public biscontrolpoint: boolean=false;
    public strdtpolygon: string='';
    public intCreatedBy:number;
    public intActionType:number;
}
export class InsertImportStationMasterModel{
    public strBusStopType: string;
    public strParentBusStop: string;
    public strBusStopName: string;
    public numLatitude: number;
    public numLongitude: number;
    public intLength: number;
    public intWidth: number;
    public strDisplayName: string;
    public strBusStopNameInRegLang1: string;
    public strBusStopNameInRegLang2: string;
    public intUserID: string;
    public strGeoStructure: string;
    public strOrganizationEntity: string;
}